import { config } from '@abyss/web/tools/config';
import { getFeature } from 'src/tools/features';
import { useQuery } from '../../tools/useQuery';

const url = `${
  getFeature('OHID_SESSION_REWORK')
    ? `${config('DS_API_URL')}/userpermissionsv2`
    : `${config('DS_API_URL')}/userpermissions`
}`;

const parseResult = result => {
  const initialState = {
    userRoles: {},
  };

  if (result) {
    return result;
  }

  return initialState;
};

export const useUserPermissions = options => {
  const queryOptions = options || {};
  queryOptions.method = 'GET';

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      const parsedData = parseResult(result.body);

      if (options && options.onCompleted) {
        options.onCompleted(parsedData);
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
